import lod_ from "lodash";
import { Divider } from "@mui/material";
import FiltersPanel from "components/Custom/Filters/FiltersPanel";

/**
 * Build the filters display for a page.
 *
 * Returns a compact filters panel (button + popover + active
 * filters chips) instead of inlining every filter component
 * in the navbar, so the bar stays usable when a page defines
 * many filters.
 *
 * @param {String} page - Actual page route
 * @param {[Object]} filters - Filters configuration of the page
 * @param {Object} resource - Resource configuration of the page
 * @param {Function} loadCharts - Callback to reload the page charts (e.g. after saving filters)
 * @returns {[JSX.Element]} - Components to display in the navbar
 */
function useFilters(page, filters, resource = {}, loadCharts = () => {}) {
	if (lod_.isEmpty(filters)) {
		return [];
	}

	return [
		<FiltersPanel
			key="filters-panel"
			page={page}
			filters={filters}
			resource={resource}
			loadCharts={loadCharts}
		/>
	];
}

export default useFilters;
